import React from 'react';
import SectionHeader from './SectionHeader';
import RYGRadio from './RYGRadio';
import NotesInput from './NotesInput';

const OPTIONS = [
  { value: 'red', label: "I'm in an employer sponsored retirement plan" },
  { value: 'yellow', label: "I'm not sure how my investment choices support and impact my financial goals" },
  { value: 'green', label: 'I have a custom-tailored investment strategy developed with my financial plan in mind' },
];

/**
 * Section 4 — Investment Alignment.
 */
export default function StepInvestmentAlignment({ data, onChange }) {
  return (
    <div>
      <SectionHeader
        number={4}
        title="How tailored are your assets and investments to your financial plan?"
        showAnnualNote={false}
      />
      <div className="cashflow-section-card">
        <RYGRadio
          id="investment_alignment"
          options={OPTIONS}
          value={data?.answer}
          onChange={(val) => onChange({ ...(data || {}), answer: val })}
        />
      </div>

      <NotesInput
        value={data?.notes}
        onChange={(val) => onChange({ ...(data || {}), notes: val })}
      />
    </div>
  );
}
